import { Link } from "react-router-dom";

const Navbar = () => {
    return (
        <nav className="navbar navbar-fixed-top custom-navbar" role="navbar">
            <div className="container">
                <div className="navbar-header">
                    <button className="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">
                        <span className="icon icon-bar"></span>
                        <span className="icon icon-bar"></span>
                        <span className="icon icon-bar"></span>
                    </button>
                    <a href="/" className="navbar-brand" style={{ padding: 0, marging: 0, display: "inlineBlock" }}>
                        <img
                            alt=''
                            className="logo img-responsive"
                            src={`${process.env.PUBLIC_URL}/images/logo.png`}
                            style={{ paddingLeft: "10px", margin: 0 }}
                        />
                    </a>
                </div>
                <div className="collapse navbar-collapse">
                    <ul className="nav navbar-nav navbar-right">
                        <li><Link to="/#home">Home</Link></li>
                        <li><Link to="/#service" >Services</Link></li>
                        <li><Link to="/#about">About</Link></li>
                        <li><Link to="/#portfolio">Portfolio</Link></li>
                        <li><Link to="/academy#home">Academy</Link></li>
                        <li><Link to="/realestate#home">Real Estate</Link></li>
                        <li><a href="#contact">Contact</a></li>
                    </ul>
                </div>
            </div>
        </nav >
    )
}

export default Navbar;